import { render, staticRenderFns } from "./InspectorList.vue?vue&type=template&id=1c74ce9e&scoped=true&"
import script from "./InspectorList.vue?vue&type=script&lang=ts&"
export * from "./InspectorList.vue?vue&type=script&lang=ts&"
import style0 from "./InspectorList.vue?vue&type=style&index=0&id=1c74ce9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74ce9e",
  null
  
)

export default component.exports